import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { TiDocumentText } from "react-icons/ti";
import axios from 'axios';
import './PropertyDetail.css';
import Ccard from '../../Components/Ccard';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const PropertyDetail = () => {
  const { id } = useParams();
  const [property, setProperty] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    axios
      .get(`https://baseapis.akari.sa/api/Property/GetPropertyById`, {
        params: { id }
      })
      .then((res) => setProperty(res.data))
      .catch((err) => {
        console.error("Error fetching property:", err);
      });
  }, [id]);

  if (!property) return <p className="loading">Loading...</p>;

  const images = Array.isArray(property.images) && property.images.length
    ? property.images
    : property.image
      ? Array.isArray(property.image) ? property.image : [property.image]
      : [];

  return (
    <div className="property-detail">
      <h1 className="title">{property.title}</h1>

      {/* Swiper Slider */}
      <div className="slider-wrapper">
        <Swiper
          modules={[Navigation, Pagination]}
          navigation
          pagination={{ clickable: true }}
          loop={true}
          className="property-swiper"
        >
          {images.map((imgSrc, index) => (
            <SwiperSlide key={index}>
              <img
                src={imgSrc}
                alt={`Slide ${index}`}
                className="swiper-image"
                onClick={() => setSelectedImage(imgSrc)} // Open lightbox
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Lightbox modal */}
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <div className="lightbox-content">
            <img src={selectedImage} alt="Full View" className="lightbox-img" />
          </div>
          <button className="close-btn" onClick={() => setSelectedImage(null)}>×</button>
        </div>
      )}

      <div className="info-container">
        <div className="card">
          <p>{property.description}</p>
        </div>
        <Ccard />
        <div className="info">
          <p><strong>📍 موقع:</strong> {property.location || property.address || 'N/A'}</p>
          <p><strong>💰 سعر:</strong> {property.price} ﷼</p>
          <p><strong>📏 المساحة:</strong> {property.area || property.propertySize} m²</p>
          <p><strong>🛏 غرف النوم:</strong> {property.bedrooms || property.bedroomNumber}</p>
          <p><strong>🚿 الحمامات:</strong> {property.bathroomNumber}</p>
          <p><strong>🛋 القاعات:</strong> {property.halls || 'N/A'}</p>
          <p><strong>🏠 عمر العقار:</strong> {property.age || 'N/A'}</p>
          <p><strong>👨‍👩‍👧‍👦 فئة:</strong> {property.category || property.propertyType}</p>
          <p><strong>👨‍👩‍👧‍👦 فئة:</strong> {property.incomepolicy }</p>
          <p><strong><TiDocumentText /> :رخصة الإعلان</strong> {property.licenseNumber || 'N/A'}</p>
        </div>
      </div>
    </div>
  );
};

export default PropertyDetail;
